

import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const EN_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "Briscola like you've never seen before: RPG, Waifu, and AI.",
      ctaWeb: "Play on Web",
      ctaAndroid: "Get for Android",
      ctaIOS: "Get for iOS", // Added
      version: "Version 2.3",
      badge: "✨ New Dungeon Mode"
    },
    stats: {
      downloads: "Downloads",
      downloadsValue: ["Countless!", "Server Full", "Too many!", "Over 9000", "Breaking Records"],
      hands: "Hands Lost",
      handsValue: ["Too many...", "Skill Issue", "Lag's fault", "Crying already?", "Try again"],
      rating: "Rating",
      ratingValue: ["Mom approves", "11/10 - IGN", "Better than pizza", "GOTY 2026", "Masterpiece"],
      waifus: "Waifus",
      waifusValue: ["All for you", "Only 2D > 3D", "Collect them all!", "Waifu > Meta", "True Treasure"]
    },
    features: {
      title: "More than just a card game",
      items: [
        { id: "classic", title: "Classic Briscola", description: "The original experience, clean and perfect.", icon: "🃏" },
        { id: "roguelike", title: "Roguelike RPG", description: "Climb the tower, get elemental powers and defeat bosses.", icon: "⚔️" },
        { id: "ai", title: "Living AI", description: "Powered by Google Gemini, opponents react to your moves in real-time.", icon: "🧠" },
        { id: "gacha", title: "Gacha System", description: "Use coins to unlock new skins and rare backgrounds.", icon: "💎" },
        { id: "dungeon", title: "Dungeon Mode", description: "Face bosses with crazy rules. One defeat and it's over.", icon: "🏰" },
        { id: "puzzle", title: "Puzzle Mode", description: "Solve complex scenarios with specific objectives.", icon: "🧩" },
      ]
    },
    video: { title: "Gameplay Trailer" },
    waifus: {
      title: "Choose your Partner",
      subtitle: "Each character has a unique personality, voice lines and playstyle.",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "The Sweet", personality: "Sweet and sunny, loves being near you." },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "The Analytic", personality: "Calculating and cold. Just logic." },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "The Tsundere", personality: "Competitive and fiery. Hates losing." },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "The Queen", personality: "The dark queen of cards." },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "The Guide", personality: "Your trusty guide... maybe." }
      ]
    },
    reviews: {
      title: "What people say (unfortunately)",
      items: getCommonReviews('en')
    },
    social: {
        title: "Join the Community",
        subtitle: "Don't miss updates, memes, and Waifu news. Follow us now!",
        discordText: "Enter the magical world of Waifu Briscola! 🌟 Join the server for exclusive news, polls, and to chat directly with devs. Your voice shapes the game!",
        discordButton: "Join the Magic"
    },
    ctaStrip: {
      title: "Ready to hit the table?",
      subtitle: "Join thousands of players and start your adventure today.",
      button: "Start Playing Now"
    },
    footer: { privacy: "Privacy", terms: "Terms", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Waifu Briscola Privacy Policy",
      lastUpdated: "Last updated: September 2, 2026",
      contact: "Contact: TotallyNotDeveloper — service@tnl.one",
      intro: "This policy explains what Waifu Briscola does with your information. The short version: the game keeps your profile and progress on your device, it does not ask for an account, and the only things that leave your device are chat messages sent to an AI, your nickname during online matches, and analytics events if you turn them on.",
      sections: [
        {
          title: "Who Is Responsible",
          body: "The data controller is TotallyNotDeveloper, the developer of Waifu Briscola. You can reach us at service@tnl.one for any question about this policy or about your data.",
        },
        {
          title: "What We Collect",
          intro: "The app never asks you to register and never asks for your name, email or phone number. It handles the following:",
          items: [
            "Profile and preferences: the nickname you choose, language, theme, audio and content settings. Stored on your device.",
            "Gameplay data: match results, coins, collected cards and characters, missions and progress. Stored on your device.",
            "Chat messages: anything you type to a character, plus the game context of that moment, is sent to an AI provider to generate a reply. See the AI section below.",
            "Multiplayer data: your nickname, a randomly generated player id and your moves, while an online match is running.",
            "Analytics: usage events such as screens opened and games started, collected only if you switch analytics on, and only while that switch stays on.",
            "Technical data: your device's IP address is visible to our servers and to the services listed below, as it is for any internet connection.",
          ],
        },
        {
          title: "Why We Use It",
          body: "To run the game and save your progress, to generate AI dialogue, to match you with other players online, and, if you consent, to understand which parts of the game are used so we can improve them.\n\nOur legal basis is the performance of the service you asked for, for everything needed to play, and your consent for analytics. You can withdraw consent at any time in Settings.",
        },
        {
          title: "AI Chat and Third Parties",
          intro: "When you chat with a character, the text you typed and the current game situation are sent to our server and then to an AI model provider:",
          items: [
            "The provider is an external AI model service, and its own privacy policy applies to that processing. The service we use may change over time.",
            "We send your message and game context. We do not send your nickname, device identifiers or any account data with it.",
            "We do not use your messages to train AI models, and we do not keep a conversation history on our servers. Your chat history stays on your device.",
            "Please do not type personal or sensitive information into the chat.",
          ],
        },
        {
          title: "Who Else Receives Data",
          intro: "We do not sell your personal information and there is no advertising in the app. Data reaches these services only for the purposes described:",
          items: [
            "Our AI provider: chat messages and game context, to generate the AI replies.",
            "PostHog, hosted in the European Union: analytics events, only with your consent.",
            "Our content delivery server: requests for game images and audio, which reveal your IP address.",
            "Other players: your nickname, visible in lobbies and during online matches.",
            "Google Play services: update and review prompts on Android, under Google's own policy.",
          ],
        },
        {
          title: "Analytics",
          body: "Nothing is collected before you accept this Privacy Policy, and nothing is collected afterwards unless you switch analytics on yourself. The switch is off when the consent screen appears, so leaving it alone means no analytics ever start.\n\nWhile it is on we record a small set of named events, such as the app opening, a game starting or a menu being viewed, together with a random identifier that is not linked to your real identity. We do not record your screen and we do not capture your taps automatically. You can turn analytics off at any time in Settings, under Privacy and data, and collection stops immediately.",
        },
        {
          title: "Online Multiplayer",
          body: "Online matches need a server. While you are in a lobby or a match, your nickname, a randomly generated player id and your moves pass through it and are visible to your opponent. Choose a nickname that does not identify you.\n\nMatches live in the server's memory only. When a match ends or the server restarts, that data is gone. Nothing about your online play is written to a database.",
        },
        {
          title: "How Long Data Is Kept",
          body: "Game data stays on your device until you delete it or uninstall the app. Multiplayer data lasts only for the duration of the match. Chat messages are not stored on our servers after a reply is produced. Analytics events, if you consented, are retained by PostHog for up to 12 months.",
        },
        {
          title: "Your Rights and Choices",
          intro: "Because the game holds no account, most of your data is directly under your control:",
          items: [
            "Delete everything: Settings, under Privacy and Data, has a Delete All My Data button. It erases your profile, progress, collection and cached images from the device permanently.",
            "Withdraw analytics consent: the same screen has an Analytics switch. Turning it off stops collection at once.",
            "Uninstalling the app also removes all locally stored data.",
            "Under the GDPR you also have the right to access, correct, port or object to processing of your data, and to complain to your local supervisory authority. Write to service@tnl.one and we will respond within 30 days.",
          ],
        },
        {
          title: "Changes to this Policy",
          body: "We may update this policy as the game changes. If a change materially affects how we handle your data, the app will ask you to review and accept the updated policy the next time you open it.",
        },
        {
          title: "Contact",
          body: "Questions, requests or complaints about this policy: service@tnl.one. We answer every message about data within 30 days.",
        },
      ],
    },
    consent: { text: "We use cookies and analytics to improve the site. By continuing you accept our", ok: "Got it" },
    terms: {
      title: "Waifu Briscola Terms and Conditions",
      lastUpdated: "Last updated: September 2, 2026",
      contact: "Contact: TotallyNotDeveloper — service@tnl.one",
      intro: "Waifu Briscola is a single-player and online card game published by TotallyNotDeveloper. These terms set out the rules for using the app (the \"Service\"). Please read them before you play.",
      sections: [
        {
          title: "Acceptance of Terms",
          body: "By accessing and using this Service, you agree to be bound by these Terms. If you disagree with any part of the terms, you may not use the Service.",
        },
        {
          title: "Use of the Service",
          body: "You agree not to use the Service for illegal or unauthorized purposes. You are responsible for your conduct and any content you provide while using the Service, including chat messages and the nickname you choose.",
        },
        {
          title: "Mature Content",
          intro: "The Service contains stylised anime artwork of adult characters, some of it suggestive in nature. You acknowledge that:",
          items: [
            "The Service is intended for a mature audience and is rated accordingly on the store you downloaded it from.",
            "Safe Mode, in Settings under Content, replaces suggestive artwork with tamer alternatives. It is switched off by default.",
            "All characters depicted are fictional adults. No real persons are portrayed.",
          ],
        },
        {
          title: "Online Multiplayer",
          body: "In online matches your chosen nickname is visible to other players in the lobby and during play. Do not use a nickname that contains personal information, or one that is offensive or impersonates someone else. We may end a match or block access if the Service is abused.",
        },
        {
          title: "Virtual Items",
          body: "Coins, cards, characters and other in-game items have no monetary value, cannot be exchanged for real money, and are stored only on your device. The Service sells nothing. Any support link inside the app is a voluntary donation to the developer and buys no in-game advantage.",
        },
        {
          title: "AI-Generated Content",
          intro: "The Service uses artificial intelligence models to generate responses, comments and game moves. You acknowledge that:",
          items: [
            "AI-generated content is produced by a model and may not always be accurate, appropriate or coherent.",
            "We are not responsible for AI-generated content.",
            "Interactions with the AI are intended for entertainment purposes only.",
            "Messages you type in chat are sent to third-party AI providers to generate a reply. Do not type anything you would not want to leave your device. See the Privacy Policy for details.",
          ],
        },
        {
          title: "Limitation of Liability",
          body: "In no event shall the developer, nor their partners, be liable for any indirect, incidental, special, consequential or punitive damages, including, without limitation, loss of profits, data, goodwill or other intangible losses, arising from (i) your access to or use of or inability to access or use the Service; (ii) any content obtained from the Service.",
        },
        {
          title: "Changes to the Terms",
          body: "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will notify you of any changes by posting the new Terms on this page.",
        },
        {
          title: "Governing Law",
          body: "These Terms shall be governed and construed in accordance with the laws of Italy, without regard to its conflict of law provisions.",
        },
      ],
    }
};
